import { BaseFiltroPagDTO } from "./base-dto";

export class PrescricaoPrescritorRelatorioFiltroDTO extends BaseFiltroPagDTO {
  dataIni: string;
  dataFim: string;
  idsClientes: number[];
  idsUnidades: number[];
  tipo: string;
  nmPrescritor: string;
  evolucao: string;
}